angular.module('ui.home',
    [
        'ui.omStat'
    ])

    .config(function ($stateProvider, $urlRouterProvider, customTemplateResolverProvider) {

        $urlRouterProvider.when('/client', '/client/home');

        $stateProvider.state('client.home', {
            url: '/home',
            template: customTemplateResolverProvider.get('home.html', 'app/ui/home/home.html'),
            controller: 'HomeController',

            data: {pageTitle: 'OrderManager: Home'}
        });
    })

    .controller('HomeController', function HomeController($q, $scope, $state, toastr, gettextCatalog,
                                                          $customisationConfig, usersRepository, workflowRepository,
                                                          permissions, homeControllerUpdatesService, uiLocalization) {

        var defaultColor = "grey";
        $scope.orderStates = [];
        $scope.allOpenOrdersCount = 0;
        $scope.isBusy = true;

        initData();
        initSignalREvents();

        function initSignalREvents() {
            homeControllerUpdatesService.onOrderItemChanged(function () {
                initData();
            });
            homeControllerUpdatesService.onNewOrderItem(function () {
                initData();
            });
            homeControllerUpdatesService.onOrderChanged(function () {
                initData();
            });
        }

        var initDataPromise;

        function initData() {

            if (initDataPromise) {
                return initDataPromise
                    .then(function () {
                        return initData();
                    }, function () {
                        return initData();
                    });
            }

            initDataPromise = $q.all([
                usersRepository.getCurrentUser(),
                workflowRepository.getSteps(),
                workflowRepository.getStepStatistics()
            ])
                .then(function (data) {
                    var restUser = data[0];
                    var steps = data[1];
                    var stepsStat = data[2];

                    //Merge steps statistics data from server with the configuratiom/customisation data
                    var stepsConfig = $customisationConfig.workflow.steps;
                    var promises = [];
                    var orderStates = [];
                    var allOpenOrdersCount = 0;

                    _.forEach(steps, function (stepModel) {
                        var step = stepModel.$model;

                        promises.push(permissions.isStepTransitionAllowed(step.id)
                            .then(function (isAllowed) {
                                var stepConfig = _.find(stepsConfig, function (s) {
                                    return s.code == step.code;
                                });
                                var stepStat = _.find(stepsStat, function (ss) {
                                    return ss.step == step.code;
                                });
                                var stepStatisticValue = angular.isDefined(stepStat) ? stepStat.numOrderItems : 0;

                                //Skip the 'ignored' in the workflow configuration steps and don't even count items on that step
                                if (stepConfig && stepConfig.ignore === true) return;
                                //Count items (to show stats on 'All orders' button, but skip step-button creation if user
                                //has no rights to view the step or its action(s) of that step.
                                allOpenOrdersCount += stepStatisticValue;
                                if (!isAllowed) return;

                                var isCustomer = restUser.isCustomer();
                                var fallbackIconForStep = function (stepCode) {
                                    return $customisationConfig.hasResource(function (res) {
                                        return _.string.contains(res, stepCode + ".")
                                    }) ? stepCode : "workflow";
                                };

                                //Info: We do localise step names using server-side localisation.
                                //This is achieved via 'sTranslate' angular filter inside the 'home view' html templates
                                orderStates.push({
                                    code: step.code,
                                    name: isCustomer ? step.publicNameResource : step.nameResource,
                                    statInfo: stepStatisticValue,
                                    color: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.color)
                                        ? stepConfig.color
                                        : defaultColor,
                                    isFloating: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.isFloating)
                                        ? stepConfig.isFloating
                                        : false,
                                    uiPriority: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.uiPriority)
                                        ? stepConfig.uiPriority
                                        : Infinity,
                                    iconName: angular.isUndefined(stepConfig) ? fallbackIconForStep(step.code) :
                                        (angular.isDefined(stepConfig.publicImageResourceName) && isCustomer
                                            ?
                                            stepConfig.publicImageResourceName
                                            : (angular.isDefined(stepConfig.imageResourceName) ?
                                            stepConfig.imageResourceName : fallbackIconForStep(step.code)))
                                });
                            }));
                    });

                    return $q.all(promises)
                        .then(function () {
                            initDataPromise = null;
                            $scope.orderStates = orderStates;
                            $scope.allOpenOrdersCount = allOpenOrdersCount;
                            $scope.isBusy = false;
                        });
                })
                .catch(function (resp) {
                    initDataPromise = null;
                    if (resp && resp.status) {
                        toastr.error(uiLocalization.translate("Data request failed. Error %s : %s", resp.status, resp.statusText));
                    } else {
                        toastr.error(gettextCatalog.getString("Data request failed"), gettextCatalog.getString("Server is not responding"));
                    }
                });

            return initDataPromise;
        }
    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('homeControllerUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType == "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType == "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType == "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })

;